<template>
  <v-snackbar 
    :value="open"
    color="green" 
    bottom outlined
    :timeout=10000
  >
    
    {{message}}
    
    <v-btn text @click="onConfirmed()">OK</v-btn>
  </v-snackbar>
</template>

<script>
export default {
  name: "Notification",
  data() {
    return {
    }
  },
  props: {
    open: Boolean, 
    message: String
  },
  methods: {
    onConfirmed(){
      this.$emit("onConfirmed");
    }
  }
};
</script>